module.exports = __webpack_public_path__ + "img/bg32.f62cbeac.png";